<div fxLayout="column" fxflex="100%">
    <div fxLayout="column" fxGrow="false">
        <div class="dhl-header-container-v2">
            <h1 class="m-Opener-headline contact-header">
                CONTACT HELP DESK
            </h1>
        </div>
    </div>
</div>
<div class="row contactus-container">
    <div class="col-xl-2"></div>
    <div class="col-xl-8">
        <div class="content-style">
            <div class="content-text-style">
                Welcome to the Supplier Registration Help Center! We stive to make the registration process as easy as
                possible. If you have any questions, concerns, or need assistance with your registration, our dedicated
                support team is here to help.
            </div>
            <h2 class="content-header-style">
                Access the “How To” Documentation
            </h2>

            <div class="content-text-style">
                Before reaching out to us, you might find the answer to your question in our “How To” document. Our “How
                To”
                document provides step by step instructions for registering your company with carrier services through
                DHL
                and Centiro.
                <span (click)="downloadFile()" class="content-hyperLink">How To Documentation</span>
            </div>


            <h2 class="content-header-style">DHL Customer Support</h2>
            <div class="content-text-style">
                If your query is not resolved through our How To, our customer support team is ready to assist you.
                Choose
                the most convenient method to get in touch with us:
            </div>
            <div class="content-text-style">
               <b>1. Email Support:</b> Send us an email at <a href="mailto:registrationhelp@dhl.com?subject=Registration%20Help&body=Please%20provide%20details%20about%20your%20issue." class="content-hyperLink">registrationhelp&#64;dhl.com</a>, and we will respond within 24 hours.
            </div>
            
            <div>

                <h2 class="content-header-style">Helpful Links to Other Carriers</h2>
                <div class="content-text-style">Use the links below to find information about your FedEx and UPS accounts</div>
                <ul class="content-ul-li">
                    <li>
                        <div>FedEx Account Questions:</div>
                        <div>
                            1. How do I find out my FedEx account number?
                            <br>
                            <a class="content-hyperLink" href="https://www.fedex.com/en-us/customer-support/faqs/fedex-account/account/how-to-find-account-number.html">https://www.fedex.com/en-us/customer-support/faqs/fedex-account/account/how-to-find-account-number.html</a>
                        </div>
                        <div>
                            2. Where can I find my FedEx invoice information?
                            <br>
                            <a class="content-hyperLink" href="https://www.fedex.com/en-ca/contact-us/faq/send-packages/fedex-billing-online/copy-invoice.html">https://www.fedex.com/en-ca/contact-us/faq/send-packages/fedex-billing-online/copy-invoice.html</a>
                        </div>
                    </li>
                    <li>
                        <div>UPS Account Questions:</div>
                        <div>
                            1. How do I find out my UPS account information?
                            <br>
                            <a class="content-hyperLink" href="https://www.ups.com/lasso/login?loc=en_US">https://www.ups.com/lasso/login?loc=en_US</a>
                        </div>
                    </li>
                    <li>
                        <div>DHL Express Account Questions:</div>
                        <div>
                            1. How do I find out my DHL Express account number?
                            <br>
                            <a class="content-hyperLink" href="https://mydhl.express.dhl/us/en/registration.html ">https://mydhl.express.dhl/us/en/registration.html</a>
                        </div>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</div>